'use client';
import Image from 'next/image';
import { ReactNode, useState } from 'react';

export const EditableInputDeprecated = ({
  children,
  value,
  disabled = false,
}: {
  children?: ReactNode;
  value: string;
  disabled?: boolean;
}) => {
  const [edit, setEdit] = useState<boolean>(false);

  return (
    <>
      {edit ? children : <span className="text-text-secondary">{value}</span>}
      {!disabled && (
        <Image
          className="cursor-pointer float-end"
          src="/icons/edit.svg"
          width={20}
          height={20}
          alt="Edit"
          onClick={() => setEdit(!edit)}
        />
      )}
    </>
  );
};
